// The g1 sport registry: every hydra wire spelling g1 renders, mapped to its
// display Sport. Worker-safe (a type-only import, no parser, no store): the
// SharedWorker builds the core floor's explicit sports list from it
// (g1xl-v2#1106, `FLOOR_WIRE_SPORTS` in workers/feedFilter). Re-exported by
// stores/marketFrameNormalization, where the ingest grammar reads it.
import type { Sport } from '../views/ValueDashboard/types';

export const SPORT_NORMALIZE: Record<string, Sport> = {
  NBA: 'nba', NFL: 'nfl', WNBA: 'wnba', NHL: 'nhl', CBB: 'cbb', CFB: 'cfb', NCAAF: 'cfb', MLB: 'mlb', ATP: 'atp', WTA: 'wta', UFC: 'ufc',
  nba: 'nba', nfl: 'nfl', wnba: 'wnba', nhl: 'nhl', cbb: 'cbb', cfb: 'cfb', ncaaf: 'cfb', mlb: 'mlb', atp: 'atp', wta: 'wta', ufc: 'ufc',
  ESPORTS: 'esports', BOXING: 'boxing', CRICKET: 'cricket', SOCCER: 'soccer',
  // Golf reaches dedicated standalone proposition selectors: futures and
  // positively identified dated match winners. It is not an away/home GameRow.
  // Normalization admits the sport; each selector still proves its own family.
  GOLF: 'golf', golf: 'golf',
  // ITF feeds both tours and Polymarket's `itf` slug carries no gender. Map it
  // to atp so parsePolyTicker doesn't drop the market (else it returns null and
  // never enters g1); getGames then routes women's ITF to the wta tab via its
  // Kalshi pair's tour. Hydra's Kalshi ITF is already folded to ATP/WTA.
  itf: 'atp', ITF: 'atp',
  esports: 'esports', boxing: 'boxing', cricket: 'cricket', soccer: 'soccer',
  // Polymarket soccer slugs carry the COMPETITION code in the sport segment
  // (PM-fifwc-… / PM-fif-…), not "soccer". Map the registered competitions
  // onto the soccer tab so parsePolyTicker resolves both the 3-way moneyline
  // and the full-game spread/total slugs. FIFA World Cup (`fifwc`) is the live
  // rollout; International Friendlies (`fif`) is parked server-side but mapped
  // here for parity with the Kalshi series list (UEFA CL is Kalshi-only). The
  // moneyline still keys its outcome off market.yesOutcome in
  // getMultiOutcomeEvents — parsePolyTicker's away-anchored outcomeCode is a
  // lower-priority fallback — so this doesn't change 3-way collapse behavior.
  fifwc: 'soccer', fif: 'soccer',
  // Club competitions (live on the edge 2026-07-31): MLS, UEFA Europa League
  // (`uel`) and UEFA Champions League (`ucl`). NOTE these are three DISTINCT
  // competitions from the Conference League (`KXUECL*`) already listed in the
  // Kalshi series map below — a whitelist written for `uecl` matches none of
  // them. Without these, parsePolyTicker returns null for every club-league
  // Poly slug and the whole venue silently disappears from the row.
  mls: 'soccer', uel: 'soccer', ucl: 'soccer', epl: 'soccer',
};
